<span class="ml-2"> ({{ queryParams | getPropIndexInObject : queryParamName }}) </span>
<app-icon *ngIf="queryParams[queryParamName] === 'asc'" name="arrow-up"></app-icon>
<app-icon *ngIf="queryParams[queryParamName] === 'desc'" name="arrow-down"></app-icon>
